export const staticPrimaryColor = '#7367F0'
export const staticPrimaryDarkenColor = '#675DD8'

const darkBaseVariables = {
    'code-color': '#d400ff',
    'overlay-scrim-opacity': 0.6,
    'hover-opacity': 0.06,
    'focus-opacity': 0.1,
    'selected-opacity': 0.08,
    'activated-opacity': 0.16,
    'pressed-opacity': 0.14,
    'dragged-opacity': 0.1,
    'disabled-opacity': 0.4,
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.9,
    'medium-emphasis-opacity': 0.7,
    'switch-opacity': 0.4,
    'switch-disabled-track-opacity': 0.4,
    'switch-disabled-thumb-opacity': 0.8,
    'switch-checked-disabled-opacity': 0.3,
    'shadow-xs-opacity': 0.16,
    'shadow-sm-opacity': 0.18,
    'shadow-md-opacity': 0.2,
    'shadow-lg-opacity': 0.22,
    'shadow-xl-opacity': 0.24,
}

export const themes = {
    light: {
        dark: false,
        colors: {
            'primary': staticPrimaryColor,
            'on-primary': '#fff',
            'primary-darken-1': '#675DD8',
            'secondary': '#808390',
            'on-secondary': '#fff',
            'secondary-darken-1': '#737682',
            'success': '#28C76F',
            'on-success': '#fff',
            'success-darken-1': '#24B364',
            'info': '#00BAD1',
            'on-info': '#fff',
            'info-darken-1': '#00A7BC',
            'warning': '#FF9F43',
            'on-warning': '#fff',
            'warning-darken-1': '#E68F3C',
            'error': '#FF4C51',
            'on-error': '#fff',
            'error-darken-1': '#E64449',
            'background': '#F8F7FA',
            'on-background': '#2F2B3D',
            'surface': '#fff',
            'on-surface': '#2F2B3D',
            'grey-50': '#FAFAFA',
            'grey-100': '#F5F5F5',
            'grey-200': '#EEEEEE',
            'grey-300': '#E0E0E0',
            'grey-400': '#BDBDBD',
            'grey-500': '#9E9E9E',
            'grey-600': '#757575',
            'grey-700': '#616161',
            'grey-800': '#424242',
            'grey-900': '#212121',
            'grey-light': '#FAFAFA',
            'perfect-scrollbar-thumb': '#DBDADE',
            'skin-bordered-background': '#fff',
            'skin-bordered-surface': '#fff',
            'expansion-panel-text-custom-bg': '#fafafa',
        },
        variables: {
            'code-color': '#d400ff',
            'overlay-scrim-background': '#2F2B3D',
            'tooltip-background': '#2F2B3D',
            'overlay-scrim-opacity': 0.5,
            'hover-opacity': 0.06,
            'focus-opacity': 0.1,
            'selected-opacity': 0.08,
            'activated-opacity': 0.16,
            'pressed-opacity': 0.14,
            'dragged-opacity': 0.1,
            'disabled-opacity': 0.4,
            'border-color': '#2F2B3D',
            'border-opacity': 0.12,
            'table-header-color': '#EAEAEC',
            'high-emphasis-opacity': 0.9,
            'medium-emphasis-opacity': 0.7,
            'switch-opacity': 0.2,
            'switch-disabled-track-opacity': 0.3,
            'switch-disabled-thumb-opacity': 0.4,
            'switch-checked-disabled-opacity': 0.3,
            'track-bg': '#F1F0F2',

            // Shadows
            'shadow-key-umbra-color': '#2F2B3D',
            'shadow-xs-opacity': 0.10,
            'shadow-sm-opacity': 0.12,
            'shadow-md-opacity': 0.14,
            'shadow-lg-opacity': 0.16,
            'shadow-xl-opacity': 0.18,
        },
    },
    dark: {
        dark: true,
        colors: {
            'primary': staticPrimaryColor,
            'on-primary': '#fff',
            'primary-darken-1': '#675DD8',
            'secondary': '#808390',
            'on-secondary': '#fff',
            'secondary-darken-1': '#737682',
            'success': '#28C76F',
            'on-success': '#fff',
            'success-darken-1': '#24B364',
            'info': '#00BAD1',
            'on-info': '#fff',
            'info-darken-1': '#00A7BC',
            'warning': '#FF9F43',
            'on-warning': '#fff',
            'warning-darken-1': '#E68F3C',
            'error': '#FF4C51',
            'on-error': '#fff',
            'error-darken-1': '#E64449',
            'background': '#25293C',
            'on-background': '#E1DEF5',
            'surface': '#292d42',
            'on-surface': '#E1DEF5',
            'grey-50': '#26293A',
            'grey-100': '#2F3349',
            'grey-200': '#26293A',
            'grey-300': '#4A5072',
            'grey-400': '#5E6692',
            'grey-500': '#7983BB',
            'grey-600': '#AAB3DE',
            'grey-700': '#B6BEE3',
            'grey-800': '#CFD3EC',
            'grey-900': '#E7E9F6',
            'grey-light': '#353A52',
            'perfect-scrollbar-thumb': '#4A5072',
            'skin-bordered-background': '#2F3349',
            'skin-bordered-surface': '#2F3349',
        },
        variables: {
            'code-color': '#d400ff',
            'overlay-scrim-background': '#171925',
            'tooltip-background': '#F7F4FF',
            'overlay-scrim-opacity': 0.6,
            'hover-opacity': 0.06,
            'focus-opacity': 0.1,
            'selected-opacity': 0.08,
            'activated-opacity': 0.16,
            'pressed-opacity': 0.14,
            'dragged-opacity': 0.1,
            'disabled-opacity': 0.4,
            'border-color': '#E1DEF5',
            'border-opacity': 0.12,
            'table-header-color': '#535876',
            'high-emphasis-opacity': 0.9,
            'medium-emphasis-opacity': 0.7,
            'switch-opacity': 0.4,
            'switch-disabled-track-opacity': 0.4,
            'switch-disabled-thumb-opacity': 0.8,
            'switch-checked-disabled-opacity': 0.3,
            'track-bg': '#3A3F57',

            // Shadows
            'shadow-key-umbra-color': '#131120',
            'shadow-xs-opacity': 0.16,
            'shadow-sm-opacity': 0.18,
            'shadow-md-opacity': 0.2,
            'shadow-lg-opacity': 0.22,
            'shadow-xl-opacity': 0.24,
        },
    },
    deepRed: {
        dark: true,
        colors: {
            'primary': '#EF5350',
            'on-primary': '#fff',
            'primary-darken-1': '#E53935',
            'secondary': '#90A4AE',
            'on-secondary': '#fff',
            'secondary-darken-1': '#78909C',
            'success': '#66BB6A',
            'on-success': '#fff',
            'success-darken-1': '#4CAF50',
            'info': '#42A5F5',
            'on-info': '#fff',
            'info-darken-1': '#2196F3',
            'warning': '#FFA726',
            'on-warning': '#fff',
            'warning-darken-1': '#FB8C00',
            'error': '#FF7043',
            'on-error': '#fff',
            'error-darken-1': '#F4511E',
            'background': '#1A1212',
            'on-background': '#F5E6E6',
            'surface': '#261A1A',
            'on-surface': '#F5E6E6',
            'grey-50': '#1E1515',
            'grey-100': '#2A1F1F',
            'grey-200': '#1E1515',
            'grey-300': '#4A3636',
            'grey-400': '#6B5252',
            'grey-500': '#8B7070',
            'grey-600': '#B09999',
            'grey-700': '#C4B3B3',
            'grey-800': '#D9CCCC',
            'grey-900': '#EDE6E6',
            'grey-light': '#352828',
            'perfect-scrollbar-thumb': '#4A3636',
            'skin-bordered-background': '#2A1F1F',
            'skin-bordered-surface': '#2A1F1F',
        },
        variables: {
            ...darkBaseVariables,
            'overlay-scrim-background': '#0D0808',
            'tooltip-background': '#F5E6E6',
            'border-color': '#F5E6E6',
            'table-header-color': '#3D2C2C',
            'track-bg': '#3A2828',
            'shadow-key-umbra-color': '#0A0505',
        },
    },
    deepPurple: {
        dark: true,
        colors: {
            'primary': '#B39DDB',
            'on-primary': '#fff',
            'primary-darken-1': '#9575CD',
            'secondary': '#90A4AE',
            'on-secondary': '#fff',
            'secondary-darken-1': '#78909C',
            'success': '#66BB6A',
            'on-success': '#fff',
            'success-darken-1': '#4CAF50',
            'info': '#42A5F5',
            'on-info': '#fff',
            'info-darken-1': '#2196F3',
            'warning': '#FFB74D',
            'on-warning': '#fff',
            'warning-darken-1': '#FFA726',
            'error': '#EF5350',
            'on-error': '#fff',
            'error-darken-1': '#E53935',
            'background': '#14121A',
            'on-background': '#E8E4F0',
            'surface': '#1E1A28',
            'on-surface': '#E8E4F0',
            'grey-50': '#181520',
            'grey-100': '#221E2D',
            'grey-200': '#181520',
            'grey-300': '#3D3650',
            'grey-400': '#5A5070',
            'grey-500': '#7A6F95',
            'grey-600': '#A499BD',
            'grey-700': '#BAB0CF',
            'grey-800': '#D0C8E0',
            'grey-900': '#E8E4F0',
            'grey-light': '#2D2840',
            'perfect-scrollbar-thumb': '#3D3650',
            'skin-bordered-background': '#221E2D',
            'skin-bordered-surface': '#221E2D',
        },
        variables: {
            ...darkBaseVariables,
            'overlay-scrim-background': '#0A080D',
            'tooltip-background': '#E8E4F0',
            'border-color': '#E8E4F0',
            'table-header-color': '#322D42',
            'track-bg': '#2D2840',
            'shadow-key-umbra-color': '#070508',
        },
    },
    deepTeal: {
        dark: true,
        colors: {
            'primary': '#4DB6AC',
            'on-primary': '#fff',
            'primary-darken-1': '#26A69A',
            'secondary': '#90A4AE',
            'on-secondary': '#fff',
            'secondary-darken-1': '#78909C',
            'success': '#81C784',
            'on-success': '#fff',
            'success-darken-1': '#66BB6A',
            'info': '#4FC3F7',
            'on-info': '#fff',
            'info-darken-1': '#29B6F6',
            'warning': '#FFB74D',
            'on-warning': '#fff',
            'warning-darken-1': '#FFA726',
            'error': '#EF5350',
            'on-error': '#fff',
            'error-darken-1': '#E53935',
            'background': '#0F1A1A',
            'on-background': '#E0F2F1',
            'surface': '#162626',
            'on-surface': '#E0F2F1',
            'grey-50': '#121E1E',
            'grey-100': '#1A2A2A',
            'grey-200': '#121E1E',
            'grey-300': '#2E4A4A',
            'grey-400': '#456666',
            'grey-500': '#608888',
            'grey-600': '#8EB5B5',
            'grey-700': '#A8CECE',
            'grey-800': '#C4E0E0',
            'grey-900': '#E0F2F1',
            'grey-light': '#203838',
            'perfect-scrollbar-thumb': '#2E4A4A',
            'skin-bordered-background': '#1A2A2A',
            'skin-bordered-surface': '#1A2A2A',
        },
        variables: {
            ...darkBaseVariables,
            'overlay-scrim-background': '#060D0D',
            'tooltip-background': '#E0F2F1',
            'border-color': '#E0F2F1',
            'table-header-color': '#243A3A',
            'track-bg': '#203838',
            'shadow-key-umbra-color': '#040808',
        },
    },
    deepGreen: {
        dark: true,
        colors: {
            'primary': '#81C784',
            'on-primary': '#fff',
            'primary-darken-1': '#66BB6A',
            'secondary': '#90A4AE',
            'on-secondary': '#fff',
            'secondary-darken-1': '#78909C',
            'success': '#A5D6A7',
            'on-success': '#fff',
            'success-darken-1': '#81C784',
            'info': '#4FC3F7',
            'on-info': '#fff',
            'info-darken-1': '#29B6F6',
            'warning': '#FFB74D',
            'on-warning': '#fff',
            'warning-darken-1': '#FFA726',
            'error': '#EF5350',
            'on-error': '#fff',
            'error-darken-1': '#E53935',
            'background': '#0F1A12',
            'on-background': '#E8F5E9',
            'surface': '#162618',
            'on-surface': '#E8F5E9',
            'grey-50': '#121E14',
            'grey-100': '#1A2A1C',
            'grey-200': '#121E14',
            'grey-300': '#2E4A32',
            'grey-400': '#45664A',
            'grey-500': '#608866',
            'grey-600': '#8EB594',
            'grey-700': '#A8CEAE',
            'grey-800': '#C4E0C8',
            'grey-900': '#E8F5E9',
            'grey-light': '#203824',
            'perfect-scrollbar-thumb': '#2E4A32',
            'skin-bordered-background': '#1A2A1C',
            'skin-bordered-surface': '#1A2A1C',
        },
        variables: {
            ...darkBaseVariables,
            'overlay-scrim-background': '#060D07',
            'tooltip-background': '#E8F5E9',
            'border-color': '#E8F5E9',
            'table-header-color': '#243A28',
            'track-bg': '#203824',
            'shadow-key-umbra-color': '#040804',
        },
    },
    jetBlack: {
        dark: true,
        colors: {
            'primary': '#7367F0',
            'on-primary': '#fff',
            'primary-darken-1': '#675DD8',
            'secondary': '#6B7280',
            'on-secondary': '#fff',
            'secondary-darken-1': '#4B5563',
            'success': '#10B981',
            'on-success': '#fff',
            'success-darken-1': '#059669',
            'info': '#3B82F6',
            'on-info': '#fff',
            'info-darken-1': '#2563EB',
            'warning': '#F59E0B',
            'on-warning': '#fff',
            'warning-darken-1': '#D97706',
            'error': '#EF4444',
            'on-error': '#fff',
            'error-darken-1': '#DC2626',
            'background': '#000000',
            'on-background': '#E5E5E5',
            'surface': '#0A0A0A',
            'on-surface': '#E5E5E5',
            'grey-50': '#0A0A0A',
            'grey-100': '#141414',
            'grey-200': '#0A0A0A',
            'grey-300': '#262626',
            'grey-400': '#404040',
            'grey-500': '#525252',
            'grey-600': '#737373',
            'grey-700': '#A3A3A3',
            'grey-800': '#D4D4D4',
            'grey-900': '#E5E5E5',
            'grey-light': '#1A1A1A',
            'perfect-scrollbar-thumb': '#262626',
            'skin-bordered-background': '#141414',
            'skin-bordered-surface': '#141414',
        },
        variables: {
            ...darkBaseVariables,
            'overlay-scrim-background': '#000000',
            'tooltip-background': '#E5E5E5',
            'border-color': '#E5E5E5',
            'table-header-color': '#1A1A1A',
            'track-bg': '#1A1A1A',
            'shadow-key-umbra-color': '#000000',
        },
    },
}

export const themeOptions = [
    { name: 'light', label: 'Light', icon: 'mdi-white-balance-sunny', color: '#F8F7FA' },
    { name: 'dark', label: 'Dark', icon: 'mdi-weather-night', color: '#25293C' },
    { name: 'jetBlack', label: 'Jet Black', icon: 'mdi-circle', color: '#000000' },
    { name: 'deepRed', label: 'Deep Red', icon: 'mdi-palette', color: '#1A1212' },
    { name: 'deepPurple', label: 'Deep Purple', icon: 'mdi-palette', color: '#14121A' },
    { name: 'deepTeal', label: 'Deep Teal', icon: 'mdi-palette', color: '#0F1A1A' },
    { name: 'deepGreen', label: 'Deep Green', icon: 'mdi-palette', color: '#0F1A12' },
]

export default themes
